import React from 'react';
import { Card } from 'react-bootstrap';
import { FaJava, FaReact, FaAws, FaJs, FaDatabase, FaTools } from 'react-icons/fa';
import { SiSpringboot, SiGit, SiDocker, SiPostman, SiVisualstudiocode } from 'react-icons/si';

const techCategories = [
  {
    title: 'Frontend',
    items: [
      { name: 'React', icon: <FaReact size={38} color="#61dafb" /> },
      { name: 'JavaScript', icon: <FaJs size={38} color="#f7df1e" /> },
    ],
  },
  {
    title: 'Backend',
    items: [
      { name: 'Java', icon: <FaJava size={38} color="#007396" /> },
      { name: 'Spring Boot', icon: <SiSpringboot size={38} color="#6db33f" /> },
      { name: 'SQL', icon: <FaDatabase size={38} color="#003545" /> },
    ],
  },
  {
    title: 'Cloud',
    items: [
      { name: 'AWS', icon: <FaAws size={38} color="#ff9900" /> },
    ],
  },
  {
    title: 'Tools',
    items: [
      { name: 'Git', icon: <SiGit size={34} color="#f34f29" /> },
      { name: 'Docker', icon: <SiDocker size={34} color="#2496ed" /> },
      { name: 'Postman', icon: <SiPostman size={34} color="#ff6c37" /> },
      { name: 'VS Code', icon: <SiVisualstudiocode size={34} color="#007acc" /> },
    ],
  },
];

const TechStack = () => (
  <div className="container section">
    <h2 className="mb-5 fw-bold text-center techstack-heading">Tech Stack</h2>
    <div className="row justify-content-center g-4">
      {techCategories.map((cat) => (
        <div className="col-12 col-md-6 col-lg-3 mb-4" key={cat.title}>
          <Card className="techstack-card h-100 shadow-sm border-0">
            <Card.Body className="d-flex flex-column align-items-center py-4">
              <h5 className="fw-bold mb-4 techstack-category-title">{cat.title}</h5>
              <div className="d-flex flex-wrap justify-content-center gap-4">
                {cat.items.map((tech) => (
                  <div key={tech.name} className="techstack-icon-card d-flex flex-column align-items-center gap-2">
                    <span className="techstack-icon mb-1">{tech.icon}</span>
                    <span className="small techstack-label">{tech.name}</span>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>
        </div>
      ))}
    </div>
  </div>
);

export default TechStack;
